import Vue from 'vue';
import { install } from '@webitel/ui-sdk/src/plugins/breakpoint/breakpoint.plugin';

install(Vue);
